export const CONST = {
    ENV: process.env.NODE_ENV,
    DEBUG: process.env.NODE_ENV !== 'production',
    EDITMODE: window.editmode,
    CONTENT_WRAPPER_MAX_WIDTH: 1440,
}

export default CONST;